__turbopack_context__.v({
  "className": "ttjenevers_b9456233-module__YdvM8q__className",
});
